import { Link } from 'react-router-dom';

import { PRODUCTS } from '../../../routes/paths';
import { EProducts } from '../../../model/enums';
import {
  handleSelectProduct,
  handleSelectProductSize,
} from '../../../store/models/cart';
import freeDeliveryIcon from '../../../assets/images/icons/free-delivery-poster-banner.png';

import styles from './styles.module.scss';
import { useLocalizedPath } from '../../../seo/useLocalizedPath';

type Props = {
  productData: any;
  productType: EProducts;
};

const ProductItem = ({ productData, productType }: Props) => {
  const { size, subscribe_price, actual_price } = productData;
  const localizePath = useLocalizedPath();
  let img = null;
  let title = null;

  switch (productType) {
    case EProducts.grs:
      img = (
        <img
          src={require(`../../../assets/images/products/grass/freshGrass_${size}_open_side.png`)}
          alt={productType}
        />
      );
      title = 'Frash Grass';
      break;
    case EProducts.acs:
      img = (
        <img
          src={require(`../../../assets/images/products/accessories/plastic-tray-${size}-base.jpg`)}
          alt={productType}
        />
      );
      title = 'Plastic Tray';
      break;
    case EProducts.ctn:
      img = (
        <img
          src={require(`../../../assets/images/products/catnips/catnip-${size}-base.jpg`)}
          alt={productType}
        />
      );
      title = 'Catnip';
      break;
    case EProducts.sds:
      img = (
        <img
          src={require('../../../assets/images/products/catgrassSeeds/1.jpg')}
          alt={productType}
        />
      );
      title = 'Catgrass Seeds';
      break;
    default:
      img = (
        <img
          src={require(`../../../assets/images/products/grass/freshGrass_${size}_open_side.png`)}
          alt={productType}
        />
      );
      title = 'Unknow Product';
      break;
  }

  function handleSelect() {
    handleSelectProduct(productData);
    handleSelectProductSize(size);
  }

  return (
    <div className={styles.productItem} onClick={handleSelect}>
      <Link to={localizePath(`${PRODUCTS}/${productType}/${size}`)}>
        <div className={styles.imgWrapper}>
          <img src={freeDeliveryIcon} className={styles.deliveryIcon} alt="" />
          {img}</div>
        <div className={styles.contentWrapper}>
          <div className={styles.title}>
            {title} ({size})
          </div>
          <div className={styles.priceWrapper}>
            <div className={styles.currentPrice}>€{subscribe_price}</div>
            {actual_price && (
              <div className={styles.prevPrice}>€{actual_price}</div>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProductItem;
